import { render } from "./CompleteDiagnosisBilling.vue?vue&type=template&id=4b580b19&scoped=true"
import script from "./CompleteDiagnosisBilling.vue?vue&type=script&lang=js"
export * from "./CompleteDiagnosisBilling.vue?vue&type=script&lang=js"

import "./CompleteDiagnosisBilling.vue?vue&type=style&index=0&id=4b580b19&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b580b19"]])

export default __exports__